import { unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

export function usePolicy() {
  const user = useMapGetter('getCurrentUser');

  const { accountId, currentAccount } = useAccount();

  const getUserPermissionsForAccount = () => {
    return getUserPermissions(user.value, accountId.value);
  };

  const isFeatureFlagEnabled = featureFlag => {
    if (!featureFlag) return true;
    if (user.value?.type === 'SuperAdmin') return true;
    return currentAccount.value?.features?.[featureFlag] === true;
  };

  const checkPermissions = requiredPermissions => {
    if (!requiredPermissions || !requiredPermissions.length) return true;
    const userPermissions = getUserPermissionsForAccount();
    return hasPermissions(requiredPermissions, userPermissions);
  };

  const shouldShow = (featureFlag, permissions) => {
    const perms = unref(permissions);
    return isFeatureFlagEnabled(featureFlag) && checkPermissions(perms);
  };

  const shouldShowPaywall = () => false;

  return {
    checkPermissions,
    shouldShowPaywall,
    isFeatureFlagEnabled,
    shouldShow,
  };
}
